export const SENDER_LOCATION_TEST_ID = 'SenderLocation';
